import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-campaign-products',
    templateUrl: './campaign-products.component.html',
    styleUrls: ['./campaign-products.component.css'],
    standalone: false
})
export class CampaignProductsComponent implements OnInit {
    campaignKeyno;

    public grid?: GridOptions;

    constructor(private stateService: StateService) {
        this.campaignKeyno = this.stateService.getStateParams()['campaign_keyno'];
    }

    private loadGrid() {
        if (!!this.campaignKeyno) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('campaignproducts.grid.list')
                    .setLoadDataFunction({
                        method: 2225,
                        parameters: { campaign_keyno: this.campaignKeyno }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
